import { render } from "./App.vue?vue&type=template&id=08de5afe&async=true"
import script from "./App.vue?vue&type=script&async=true&lang=js"
export * from "./App.vue?vue&type=script&async=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=08de5afe&async=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__